<script setup>
const props = defineProps({
  value: Boolean,
  disabled: {
    type: Boolean,
    default: false,
  },
  attributes: Object,
})
const emit = defineEmits(['input'])

function inputChange() {
  emit('input', !props.value)
}

function styleChange() {
  if (props.value) {
    return { backgroundColor: props.attributes?.primary_color || '#0099d0' }
  }
  return '#F8F8F8'
}
</script>

<template>
  <label class="switch">
    <input type="checkbox" :checked="value" :disabled="disabled" @input="inputChange" />
    <span class="slider round" :style="styleChange()"></span>
  </label>
</template>

<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 56px;
  height: 30px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 22px;
  width: 22px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #0099d0;
}

input:focus + .slider {
  box-shadow: 0 0 1px #0099d0;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
